import StackKit from "@/shared/components/kit/stack";
import React from "react";
/**
 * CardBoxLayout
 *
 * یک لایه کارت‌بندی شده که برای نمایش محتوای داخلی با استایل مشخص استفاده می‌شود.
 *
 * ویژگی‌ها:
 * - نمایش محتوا به صورت ستونی (column)
 * - ارتفاع حداقل 456px و حداکثر 700px
 * - پس‌زمینه خاکستری (#434343) و گوشه‌های گرد
 * - فضای داخلی (padding) 1 واحد
 * - فعال بودن اسکرول برای محتوای طولانی
 * - امکان اعمال استایل دلخواه از طریق prop `sx`
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - محتوای داخلی کارت
 * @param {any} [props.sx] - استایل‌های اضافی برای سفارشی‌سازی ظاهر کارت
 *
 * @returns JSX.Element
 */

const CardBoxLayout = ({children,sx,}: { children: React.ReactNode; sx?: any;}) => {
  return (
    <StackKit direction="column" className="w-full max-h-[700px] bg-[#434343] justify-start p-1 rounded-2xl overflow-auto" sx={{...sx,}} >
      {children}
    </StackKit>
  );
};

export default CardBoxLayout;
